import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  getDiets,
  getHousingTypes,
  getCareTyping,
  getCookingForms,
  createDepartment,
  getLocations,
} from "../../services";
import { MultiSelect } from "../../components";

const DepartmentCreate = (props) => {
  useEffect(() => {
    console.log(props.locationId);
    // Diets will not be implemented in MVP
    // getDiets().then(list => {
    //   setDietArray(list);
    // })
    getLocations(props.customerId).then((list) => {
      setLocationArray(list);
    });
    getHousingTypes().then((list) => {
      setHousingTypeArray(list);
    });
    getCareTyping().then((list) => {
      setCareTypingArray(list);
    });
    getCookingForms().then((list) => {
      setCookingFormArray(list);
    });
  }, []);

  const newDepartment = () => {
    createDepartment(
      location,
      name,
      housingType,
      careTyping,
      cookingForm,
      patientsAmount,
      patientsDietAmount,
      VSE
    );
    setCookingForm("");
    setPatientsAmount("");
    setPatientsDietAmount("");
    setName("");
    setCareTyping("");
    setHousingType("");
    setLocation("");
    document.getElementById("selectbox__housing_type").selectedIndex = 0;
    document.getElementById("selectbox__location").selectedIndex = 0;
  };

  const [patientsAmount, setPatientsAmount] = useState();
  const [patientsDietAmount, setPatientsDietAmount] = useState();
  const [name, setName] = useState();
  const [housingType, setHousingType] = useState();
  const [careTyping, setCareTyping] = useState();
  const [location, setLocation] = useState();
  const [cookingForm, setCookingForm] = useState();
  const [VSE, setVSE] = useState();
  const [diets, setDiets] = useState();

  // Lists from database
  const [dietArray, setDietArray] = useState();
  const [housingTypeArray, setHousingTypeArray] = useState();
  const [locationArray, setLocationArray] = useState();
  const [careTypingArray, setCareTypingArray] = useState();
  const [cookingFormArray, setCookingFormArray] = useState();

  const submitDepartment = () => {
    createDepartment(
      location,
      name,
      housingType,
      careTyping,
      cookingForm,
      patientsAmount,
      patientsDietAmount,
      VSE
    );
    props.next()
  };

  return (
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Afdelingsgegevens</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Locatie</span>
          <select
            required="true"
            id="selectbox__location"
            onChange={(e) => setLocation(e.target.value)}
            className="form__fields__field__input"
          >
            <option>Selecteer een locatie</option>
            {locationArray}
          </select>
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Afdelingsnaam</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Aantal dieet</span>
          <input
            value={patientsDietAmount}
            onChange={(e) => setPatientsDietAmount(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Aantal zorgbehoevende
          </span>
          <input
            value={patientsAmount}
            onChange={(e) => setPatientsAmount(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Standaard verstrekkingseenheid in grammen
          </span>
          <input
            // required="true"
            onChange={(e) => setVSE(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Zorgtypering</span>
          <MultiSelect
            array={careTypingArray}
            value={careTyping}
            update={setCareTyping}
            label="Selecteer een zorgtypering"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Woonvorm</span>
          <select
            required="true"
            id="selectbox__housing_type"
            onChange={(e) => setHousingType(e.target.value)}
            className="form__fields__field__input"
          >
            <option>Selecteer een woonvorm</option>
            {housingTypeArray}
          </select>
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Kookvorm</span>
          <MultiSelect
            array={cookingFormArray}
            value={cookingForm}
            update={setCookingForm}
            label="Selecteer een kookvorm"
          />
        </div>
        {/* Diets not part of MVP */}
        {/* <div className="form__fields__field">
          <span className="form__fields__field__label">Dieëten</span>
            <MultiSelect
            array={dietsArray}
            value={diets}
            update={setDiets}
          />
            <option>Selecteer een dieet</option>
            {dietArray}
          </select>
        </div> */}
        <button
          className="form__container__content__button"
          onClick={() => submitDepartment()}
        >
          OPSLAAN <i className="fas fa-arrow-right"></i>
        </button>
        <button
          className="form__container__content__button"
          onClick={() => newDepartment()}
        >
          Nieuwe afdeling <i className="fas fa-plus"></i>
        </button>
      </div>
    </div>
  );
};

export default withRouter(DepartmentCreate);
